import {
    UPDATE_UPLOADED_COMMENTS_RELEVANT_BEGIN,
    UPDATE_UPLOADED_COMMENTS_RELEVANT_SUCCESS,
    UPDATE_UPLOADED_COMMENTS_RELEVANT_FAILURE,
  } from './constants';
  import http from '../../../common/http';
  import { apiEndPoints } from '../../../common/globalConstants';
  
  export function updateUploadedCommentsRelevant(props = {}) {
    return dispatch => {
      dispatch({
        type: UPDATE_UPLOADED_COMMENTS_RELEVANT_BEGIN,
      });
      const url = `${apiEndPoints.comments.UPDATE_COMMENT_RELEVANT}?commentId=${props.commentOrPostId}&relevance=${props.relevance}`;
      const promise = new Promise((resolve, reject) => {
        const doRequest = http.patch(url);
        doRequest.then(
          res => {
            let mergedPropsAndResponse = {...props, ...res.data};
            dispatch({
              type: UPDATE_UPLOADED_COMMENTS_RELEVANT_SUCCESS,
              data: mergedPropsAndResponse,
            });
            resolve(res);
          },
          err => {
            dispatch({
              type: UPDATE_UPLOADED_COMMENTS_RELEVANT_FAILURE,
            });
            reject(err);
          },
        );
      });
      return promise;
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case UPDATE_UPLOADED_COMMENTS_RELEVANT_BEGIN:
        return {
          ...state,
          updateUploadedCommentsRelevantBegin: true,
          updateUploadedCommentsRelevantSuccess: false,
          updateUploadedCommentsRelevantFailure: false,
          updateCommentsRelevantSuccess: false,
          updateCommentsRelevantFailure: false,
          updateFeedsRelevantSuccess: false,
          updateFeedsRelevantFailure: false,
          updateTweetsRelevantSuccess: false,
          updateTweetsRelevantFailure: false,
          commentOrTweetAfterRelevanceUpdates: null
        };
      case UPDATE_UPLOADED_COMMENTS_RELEVANT_SUCCESS: {
        const updatedUploadedComments = state.allUploadedComments.data.map(comment => {
          if (comment.commentId === action.data.commentOrPostId) {
            comment.relevance = action.data.relevance;
            state.commentOrTweetAfterRelevanceUpdates = comment;
          }
          return comment;
        });
        state.allUploadedComments.data = updatedUploadedComments;
        return {
          ...state,
          updateUploadedCommentsRelevantBegin: false,
          updateUploadedCommentsRelevantSuccess: true,
        };
      }
      case UPDATE_UPLOADED_COMMENTS_RELEVANT_FAILURE:
        return {
          ...state,
          updateUploadedCommentsRelevantBegin: false,
          updateUploadedCommentsRelevantFailure: true,
        };
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/home/redux/updateUploadedCommentsRelevant.js